import collectionCopy from "./collection-copy.json";

function titleCaseSlug(slug = "") {
  return String(slug)
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function genderPossessive(gender = "") {
  if (gender === "women") return "Women's";
  if (gender === "men") return "Men's";
  return "";
}

function buildFallbackTitle(pageGender, pageValue) {
  const gender = genderPossessive(pageGender);
  const value = titleCaseSlug(pageValue);
  return [gender, value].filter(Boolean).join(" ");
}

export function resolvePageCopy({
  page,
  pageGender,
  pageValue,
  view = "desktop",
}) {
  const entry = collectionCopy[page] || {};
  const title =
    entry[`title_${view}`] ||
    entry.title ||
    buildFallbackTitle(pageGender, pageValue);
  const subtitle = entry[`subtitle_${view}`] || entry.subtitle || "";

  return {
    title: String(title).trim(),
    subtitle: String(subtitle).trim(),
  };
}
